<template>
  <div>
    <div class="content">
      <ins-scheme @useScheme="useScheme"></ins-scheme>
      <basic-info ref="basicInfo"></basic-info>
      <div class="policy-holder-title">
        <p class="title">投保人信息</p>
        <p class="name" @click="changePolicyShow">{{ applicantInfoList[0].name }}</p>
      </div>
      <table class="policy-holder-info" cellpadding="0" cellspacing="0" v-show="showPolicyInfo">
        <tr>
          <td>证件号码</td>
          <td>
            {{ applicantInfoList[0].certificateNo }}
          </td>
        </tr>
        <tr>
          <td>手机号</td>
          <td>
            {{ applicantInfoList[0].mobile }}
          </td>
        </tr>
      </table>
      <div class="insured-person-title">被保人信息</div>
      <div class="insured-person-switch" :class="{ same: isSamePerson === 1 }" @click="changInsInfo">同投保人</div>
      <table class="insured-holder-info" cellpadding="0" cellspacing="0" v-show="isSamePerson === 0">
        <tr>
          <td>被保人类型</td>
          <td>
            <div :class="{ select: insurantInfoList[0].personnelType === '1', unselect: insurantInfoList[0].personnelType === '0' }" @click="changeInsuredType('1')">个人</div>
            <div :class="{ select: insurantInfoList[0].personnelType === '0', unselect: insurantInfoList[0].personnelType === '1' }" @click="changeInsuredType('0')" style="margin-left: 2.67vw">
              团体
            </div>
          </td>
        </tr>
        <tr>
          <td>姓名/公司名</td>
          <td>
            <valid :content="name" :min="2" :max="100" ref="valid0">
              <input type="text" v-model="name" placeholder="请输入姓名/公司名" minlength="2" maxlength="100" />
            </valid>
          </td>
        </tr>
        <tr>
          <td>证件类型</td>
          <td>
            <div>{{ insuredIdType }}</div>
          </td>
        </tr>
        <tr>
          <td>证件号码</td>
          <td>
            <valid :content="certificateNo" :max="18" :validator="validator.idNo" ref="valid1">
              <input type="text" v-model="certificateNo" placeholder="请输入证件号" minlength="2" maxlength="18" />
            </valid>
          </td>
        </tr>
      </table>
      <!-- <div class="notice">
                <div class="check-btn" :class="{'selected':readNotice}" @click="changeNoticeSelect"></div>
                <p>我已确认<span @click="openNotice(0)">《投保须知》</span>、<span @click="openNotice(1)">《保险条款》</span>。</p>
            </div> -->
    </div>
    <div class="loading" v-show="showLoading">
      <div class="spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
    </div>
    <customer-dialog v-show="showDialog" :title="dialogTitle" @confirm="confirmDialog" @cancel="cancelDialog">
      <p v-show="dialogType === 'recharge'">可用保费余额不足<br />请去预缴保费</p>
      <div v-show="dialogType === 'insure'">
        <p style="text-align: left" v-show="riskGroupInfoList[0].cargoType === '0'">本保险方案承保普通货物，<span style="font-weight: bold">不承保以下货物</span>，如用户投保以下货物，保险公司有权拒赔：</p>
        <p style="text-align: left" v-show="riskGroupInfoList[0].cargoType === '-1'">本保单承保散货（无规则包装货物），但<span style="font-weight: bold">仅承保</span>下述列明标的的保险责任，保险标的：</p>
        <p style="text-align: left" v-show="riskGroupInfoList[0].cargoType === '4'">本保单承保易碎易损品，本保单<span style="font-weight: bold">仅承保</span>下述列明标的的保险责任，保险标的：</p>
        <p style="text-align: left" v-show="riskGroupInfoList[0].cargoType === '5'">本保单承保散货生鲜及冷藏品，但<span style="font-weight: bold">仅承保</span>：</p>
        <div v-show="riskGroupInfoList[0].cargoType === '0'" style="text-align: left">
          <p>1）新鲜水果、新鲜蔬菜、鲜花、鲜活动植物； </p>
          <p>2）大宗散货（包括散装的农产品、化工产品、油品）；各类农作物、粮食类货物（包括但不限于花生、大蒜、葵花籽、线麻籽、豆粕、鱼粉、非袋装白糖、葫芦籽）；棉包；</p>
          <p>3）疫苗、针剂、液体药品、试剂、血液制品；</p>
          <p>4）工艺品（包括各类雕刻、编织、艺术品、刺绣、古董、字画、瓷器、玉雕及其他玉石制品等）、现金、有价证券、珠宝、具有收藏价值的货物以及计算机软件等难以客观确定保险价值的货物；</p>
          <p>5）大型港口机械设备、大型铸件、风力发电相关设备、商品车整车及发动机、变速器、车架、车壳以及新能源车电池组、航空器、游艇、船舶及有关运输设备、武器、弹药及其零配件；</p>
          <p>6）精密仪器（精密仪器的判断条件是:A.对运输有特别的防震动、防倾斜、防尘等特殊要求。B.受国内维修能力所限，设备受损后无法在国内修复。C.单件货物保额超过RMB200万元。满足上述条件之一的即为精密设备或仪器）；</p>
          <p>7）红木家具、进口家具;</p>
          <p>9）任何冷藏、冷冻及温控货物；易碎货物；</p>
          <p>10）铝卷、纸卷；</p>
          <p>11）任何被保险人不具承运资质的标的。</p>
        </div>
        <p v-show="riskGroupInfoList[0].cargoType === '-1'" style="text-align: left">仅指煤炭/钢材/矿石/水泥/化肥/粮食。</p>
        <p v-show="riskGroupInfoList[0].cargoType === '-1'" style="text-align: left; margin-top: 1.33vw">其他标的发生保险事故，保险人不负责赔偿。</p>
        <div v-show="riskGroupInfoList[0].cargoType === '4'" style="text-align: left">
          <p>陶瓷、瓷砖及其制品（工艺品除外）；大理石、石料及其制品（工艺品除外）；砖、瓦、砌块；玻璃/陶瓷瓶装酒水饮料；液晶面板/屏、钟表；手机、电脑、液晶电视、液晶显示器、平板电脑、数码相机以及其他电子3c产品、太阳能面板、光伏产品、太阳能组件、半导体、硅晶片（单硅晶片、多硅晶片），玻璃制品（平板玻璃原片除外）。</p>
          <!-- <p style="margin-top: 1.33vw">投保非上述列明货物，保险公司有权拒赔。</p> -->
        </div>
        <p v-show="riskGroupInfoList[0].cargoType === '5'" style="text-align: left">蔬菜水果、冷藏（冷冻肉产品）、生鲜食品，不含西瓜和番茄。</p>
        <!-- <p v-show="riskGroupInfoList[0].cargoType === '5'" style="text-align: left; margin-top: 1.33vw">投保非上述列明货物，保险公司有权拒赔。</p> -->
      </div>
    </customer-dialog>
    <div class="submit">
      <!--<div class="scheme" :class="{'select':isSaveUse === 1}" @click="setScheme">-->
      <!--设为常用-->
      <!--</div>-->
      <div class="customer" @click="callPhone">联系客服</div>
      <div class="price">￥{{ payMoney }}</div>
      <div class="submit-btn" @click="payconfirm">立即支付</div>
    </div>
    <customer-dialog v-show="showTip" @confirm="confirmTip" @cancel="cancelTip" title="条款确认" confirmbtn="同意" showCancel="false">
      <div class="notice" style="font-size: 3.73vw; color: #111111">
        <p style="color: #333">
          我已阅读并同意 <span @click="openNotice(1)">《保险条款》</span><span @click="openNotice(0)">《投保须知》</span>
          <span @click="openNotice(3)">《客户告知书》</span>
          <span v-if="insurantInfoList[0].personnelType === '1'" @click="openNotice(2)">《被保人同意确认书》</span>
        </p>
      </div>
      <div class="notice">本产品由中国平安财险保险有限公司承保<br />由天津华盛经纪保险有限公司销售</div>
    </customer-dialog>
    <router-view></router-view>
    <!-- <legalHome v-if="showLegal" @closeLegal="closeLegal"></legalHome> -->
    <div v-if="customerServiceVisibile">
      <div class="mask"></div>
      <iframe frameborder="0" class="iframeService" :src="serviceUrl"></iframe>
    </div>
  </div>
</template>

<script>
import InsScheme from "./InsScheme";
import BasicInfo from "./BasicInfo";
import { mapGetters, mapState } from "vuex";
import CustomerDialog from "./Dialog";
import Valid from "./Valid";
import { getUrlParams, deepClone, showMsg, getSessionObj, setSessionObj, getUserInfo } from "../common/utils";
import { chineseAndChar, getAgeByIdCard, isChinese, isIdCard, onlyNumAndChar } from "../common/validaRule";
import { myTrack } from "../common/track";
// import legalHome from '../components/legalHome/legalHome';
const payUrl = "/hsbxjj-excellent-driving-insurance/order/xbdInsureOrderApplyApp";
const infoUrl = "/hsbxjj-excellent-driving-insurance/suborder/getYjbXbdInputInfo";

export default {
  name: "Certificate",
  components: {
    InsScheme,
    BasicInfo,
    CustomerDialog,
    Valid,
    // legalHome
  },
  computed: {
    ...mapGetters("certificate", ["insuredIdType"]),
    ...mapState("certificate", ["payMoney", "isSaveUse", "applicantInfoList", "insurantInfoList", "isSamePerson", "mainOrderId", "riskGroupInfoList", "balance"]),
    name: {
      get() {
        return this.insurantInfoList[0].name.replace(/[• .]/g, "·");
      },
      set(val) {
        this.$store.commit("certificate/setName", val);
      },
    },
    certificateNo: {
      get() {
        return this.insurantInfoList[0].certificateNo;
      },
      set(val) {
        this.$store.commit("certificate/setCertificateNo", val);
      },
    },
  },
  data() {
    let nameValid = (str) => {
      if (this.insurantInfoList[0].personnelType === "1") {
        return isChinese(str);
      } else {
        return chineseAndChar(str);
      }
    };
    let idValid = (str) => {
      if (this.insurantInfoList[0].personnelType === "1") {
        return isIdCard(str) && getAgeByIdCard(str) > 17;
      } else {
        return onlyNumAndChar(str) && str.length === 18;
      }
    };
    return {
      customerServiceVisibile: false,
      serviceUrl: `${window.location.origin}/hsbxjj-standard-common-insurance-page/#/customerService`,
      validator: {
        name: nameValid,
        idNo: idValid,
      },
      //投保人信息显示切换
      showPolicyInfo: false,
      //是否阅读条款
      readNotice: false,
      //加载效果
      showLoading: false,
      //弹窗
      showDialog: false,
      dialogTitle: "",
      dialogType: "",
      showTip: false,
      backtrackingCode: "",
      showLegal: false,
    };
  },
  methods: {
    confirmTip() {
      this.doInsure();
      this.showTip = false;
    },
    payconfirm() {
      let basicFlag = this.$refs.basicInfo.validation();
      //被保人输入框校验
      let flag = false;
      for (let i = 0; i < 2; i++) {
        if (this.$refs["valid" + i].validation()) {
          flag = true;
        }
      }
      if (flag || basicFlag) {
        return;
      }
      this.confirmTip();
      // this.showTip = true;
    },
    cancelTip() {
      try {
        // myTrack("小保单投保确认页-须知弹窗-点击取消", {
        //     "产品名称": "优驾保UBI网络物责险",
        //     '运营渠道': getUrlParams().orderSource ? getUrlParams().orderSource : ""
        // });
      } catch (e) {}
      this.showTip = false;
    },
    // closeLegal(){
    //     this.showLegal = false;
    // },
    changInsInfo() {
      if (this.isSamePerson === 1) {
        this.$store.commit("certificate/setSamePerson", 0);
        //切换是否同投保人，清空名称和证件号
        this.$store.commit("certificate/setName", "");
        this.$store.commit("certificate/setCertificateNo", "");
      } else {
        this.$store.commit("certificate/setSamePerson", 1);
        //同投保人,被保人信息复制到投保人
        //必须拷贝，否则指向同一内存空间，会联动
        let data = deepClone(this.applicantInfoList);
        this.$store.commit("certificate/setInsuredInfoList", data);
      }
    },
    changePolicyShow() {
      this.showPolicyInfo = !this.showPolicyInfo;
    },
    changeInsuredType(type) {
      this.$store.commit("certificate/setPersonType", type);
      //切换投保人类型，清空名称和证件号
      this.$store.commit("certificate/setName", "");
      this.$store.commit("certificate/setCertificateNo", "");
    },
    changeNoticeSelect() {
      this.readNotice = !this.readNotice;
    },
    openNotice(type) {
      if (type === 0) {
        this.$router.push({ path: "certificate/InsNotice" });
      } else if (type === 1) {
        this.$router.push({ path: "certificate/InsClause" });
      } else if (type == 2) {
        this.$router.push({ path: "certificate/InsClause1" });
      } else if (type == 3) {
        this.$router.push({ path: "certificate/CustomerPage" });
      }
    },
    doInsure() {
      // if (!this.readNotice){
      //     showMsg("请阅读条款");
      //     return true;
      // }
      //basicInfo的校验
      // let basicFlag = this.$refs.basicInfo.validation();
      // //被保人输入框校验
      // let flag = false;
      // for (let i=0; i<2; i++){
      //     if (this.$refs['valid'+i].validation()){
      //         flag = true;
      //     }
      // }
      // if (flag || basicFlag){
      //     return;
      // }
      if (!this.backtrackingCode) {
        if (window.insurebacktrackingCode) {
          this.backtrackingCode = window.insurebacktrackingCode;
        } else {
          if (window.getIseeBiz) {
            let self = this;
            window.getIseeBiz().then((res) => {
              self.backtrackingCode = res;
            });
          }
        }
      }
      this.dialogTitle = "投保货物须知";
      this.dialogType = "insure";
      this.showDialog = true;
    },
    useScheme() {
      if (this.isSamePerson === 1) {
        this.$store.commit("certificate/setSamePerson", 1);
        //同投保人,被保人信息复制到投保人
        //必须拷贝，否则指向同一内存空间，会联动
        let data = deepClone(this.applicantInfoList);
        this.$store.commit("certificate/setInsuredInfoList", data);
      }
      this.$refs.basicInfo.changeAmountStatus();
      this.$refs.basicInfo.getPayMoney();
    },
    confirmDialog() {
      if (this.dialogType === "insure") {
        let data = this.$store.state.certificate;
        data.backtrackingCode = this.backtrackingCode;
        setSessionObj("pageData", this.$store.state.certificate);
        if (Number(this.balance) >= Number(this.payMoney)) {
          //余额够用
          this.showDialog = false;
          this.showLoading = true;
          data = encodeURIComponent(JSON.stringify(data));
          let encodeData = window.$EncryptUtils.compile(data, [{ requestContentType: 1 }, { userId: "fa929050330644e68eed7f88a6331eak" }]);
          this.$http
            .post(payUrl, encodeData)
            .then((res) => {
              this.showLoading = false;
              if (res.data.flag) {
                //下单成功，跳转支付成功页
                location.href = process.env.VUE_APP_CALLBACKURL + "?order_no=" + res.data.data.subOrderId + "&certificate=true";
              } else {
                showMsg(res.data.message);
              }
            })
            .catch(() => {
              this.showLoading = false;
            });
        } else {
          //余额不够
          this.dialogTitle = "提示";
          this.dialogType = "recharge";
        }
      } else {
        let urlParams = JSON.parse(decodeURIComponent(getUrlParams().params));
        let params = deepClone(this.applicantInfoList[0]);
        params.balance = this.balance;
        params.orderId = this.mainOrderId;
        params.policyCode = urlParams.policyCode;
        params.orderOwnerId = getUserInfo().userId;
        params.backtrackingCode = this.backtrackingCode;
        params.from = "certificate";
        this.$router.push({ name: "recharge", params });
        this.showDialog = false;
      }
    },
    cancelDialog() {
      this.showDialog = false;
    },
    callPhone() {
      this.customerServiceVisibile = true;
      try {
        myTrack("bxsc_customer_service", {
          customer_service_page: "优驾保UBI网络物责险(小保单)",
          product_channel: getUrlParams().orderSource ? getUrlParams().orderSource : "",
        });
      } catch (error) {}
    },
  },
  mounted() {
    var that = this;
    window.addEventListener(
      "message",
      function (type) {
        if (type.data.hasOwnProperty("action") && type.data.action == "closeCustomerService") {
          // 接收联系客服关闭按钮事件
          that.customerServiceVisibile = false;
        }
      },
      false
    );
    try {
      // myTrack("进入小保单投保确认页", {
      //     "产品名称": "优驾保UBI网络物责险",
      //     '运营渠道': getUrlParams().orderSource ? getUrlParams().orderSource : ""
      // });
    } catch (e) {}
    let urlParams = getUrlParams();
    if (window.daka && getUrlParams().hp == 1) {
      this.showLegal = false;
    } else {
      this.showLegal = true;
    }
    if (urlParams.order_no) {
      //再来一单，直接回填所有数据
      this.$http.get(infoUrl, { params: { subOrderId: urlParams.order_no } }).then((res) => {
        if (res.data.flag) {
          let pageData = res.data.data;
          //数据回填
          this.$store.commit("certificate/setRiskGroupInfo", pageData.riskGroupInfoList);
          //数据不要车牌号
          // this.$store.commit('certificate/setVehicleNo',pageData.vno);
          this.$store.commit("certificate/setAmount", pageData.totalInsuredAmount);
          this.$store.commit("certificate/setSamePerson", pageData.isSamePerson);
          this.$store.commit("certificate/setInsuredInfoList", pageData.insurantInfoList);
          this.$store.commit("certificate/setApplicantInfoList", pageData.applicantInfoList);
          this.$store.commit("certificate/setOrderId", pageData.mainOrderId);
          this.$store.commit("certificate/setBalance", pageData.UserBalance);
          //回填保额状态需要和使用常用投保方案一样
          //判断是否保额在自定义范围
          this.$refs.basicInfo.changeAmountStatus();
          this.$refs.basicInfo.getPayMoney();
        }
      });
    } else {
      //有缓存，回填填入的用户信息
      let pageData = getSessionObj("pageData");
      if (pageData) {
        //数据回填
        this.$store.commit("certificate/setRiskGroupInfo", pageData.riskGroupInfoList);
        this.$store.commit("certificate/setVehicleNo", pageData.vno);
        this.$store.commit("certificate/setAmount", pageData.totalInsuredAmount);
        this.$store.commit("certificate/setSamePerson", pageData.isSamePerson);
        this.$store.commit("certificate/setInsuredInfoList", pageData.insurantInfoList);
        this.$store.commit("certificate/setApplicantInfoList", pageData.applicantInfoList);
        this.$store.commit("certificate/setOrderId", pageData.mainOrderId);
        //回填保额状态需要和使用常用投保方案一样
        //判断是否保额在自定义范围
        this.$refs.basicInfo.changeAmountStatus();
      }
      //回填url带进来的投保人信息
      let params = JSON.parse(decodeURIComponent(getUrlParams().params));
      let insuredPerson = {};
      insuredPerson.certificateType = params.certificateType;
      insuredPerson.personnelType = params.personnelType;
      insuredPerson.name = params.name;
      insuredPerson.certificateNo = params.certificateNo;
      insuredPerson.mobile = params.mobile;
      this.$store.commit("certificate/setApplicantInfoList", [insuredPerson]);
      this.$store.commit("certificate/setOrderId", params.orderId);
      if (this.isSamePerson === 1) {
        //必须拷贝，否则指向同一内存空间，会联动
        let data = deepClone(insuredPerson);
        this.$store.commit("certificate/setInsuredInfoList", [data]);
      }
      console.log(JSON.stringify(this.$store.state));
      if (pageData) {
        //如果触发了回填数据，则重新查询价格
        this.$refs.basicInfo.getPayMoney();
      }
    }
  },
};
</script>

<style scoped lang="scss">
.base-table {
  width: 100%;
  background: #ffffff;

  tr {
    height: 13.33vw;
    line-height: 13.33vw;

    td {
      border-bottom: 0.27vw solid #f5f5f9;
    }

    td:nth-child(1) {
      min-width: 35vw;
      padding-left: 5.33vw;
      text-align: left;
      color: #333333;
    }

    td:nth-child(2) {
      padding-right: 5.33vw;
      text-align: right;
      color: #666666;
    }
  }
}

.basic-select {
  display: inline-block;
  width: 17.33vw;
  height: 8vw;
  margin-right: 2.67vw;
  line-height: 8vw;
  text-align: center;
  vertical-align: middle;
  border-radius: 4vw;
}

.content {
  position: absolute;
  width: 100vw;
  bottom: 14.67vw;
  top: 0;
  overflow: auto;

  .policy-holder-title {
    display: flex;
    height: 12vw;
    padding: 0 5.33vw;
    margin-top: 2.67vw;
    line-height: 12vw;
    justify-content: space-between;
    font-size: 4.27vw;
    background: #ffffff;

    .title {
      padding-left: 5.33vw;
      text-align: left;
      font-weight: bold;
      background: url(../assets/person-b.png) no-repeat left center;
      background-size: 4vw;
    }

    .name {
      padding-right: 4.53vw;
      color: #666666;
      background: url(../assets/down.png) no-repeat right center;
      background-size: 2.67vw;
    }
  }

  .policy-holder-info {
    @extend .base-table;
  }

  .insured-person-title {
    height: 12vw;
    padding-left: 10.67vw;
    margin-top: 2.67vw;
    text-align: left;
    line-height: 12vw;
    font-size: 4.27vw;
    font-weight: bold;
    background: url(../assets/person-o.png) no-repeat 5.33vw center #ffffff;
    background-size: 4vw;
  }

  .insured-person-switch {
    height: 10.67vw;
    padding-left: 5.33vw;
    line-height: 10.67vw;
    text-align: left;
    background: url(../assets/switch-bar-2.png) no-repeat right 5.33vw center #ffffff;
    background-size: 12vw;
    border-bottom: 0.27vw solid #f5f5f9;
  }

  .insured-holder-info {
    .select {
      color: #3385ff;
      background: #dceaff;
      border: 0.27vw solid #3385ff;
      @extend .basic-select;
    }

    .unselect {
      color: #999999;
      background: #ffffff;
      border: 0.27vw solid #cccccc;
      @extend .basic-select;
    }

    @extend .base-table;
  }

  .same {
    background: url(../assets/switch-bar-1.png) no-repeat right 5.33vw center #ffffff;
    background-size: 12vw;
  }

  .notice {
    display: flex;
    padding: 2vw 0vw;
    font-size: 3.2vw;
    text-align: left;
    color: #999;

    .check-btn {
      width: 5.33vw;
      height: 5vw;
      background: url("../assets/uncheck.png") no-repeat center;
      background-size: 3.2vw;
    }

    .selected {
      background: url("../assets/checked.png") no-repeat center;
      background-size: 3.2vw;
    }

    p {
      width: 87vw;
      line-height: 5vw;

      span {
        color: #3385ff;
      }
    }
  }
}

.submit {
  position: absolute;
  display: flex;
  bottom: 0;
  height: 14.67vw;
  width: 100vw;
  justify-content: space-around;

  .customer {
    width: 15.73vw;
    padding-top: 8.67vw;
    border-right: 0.27vw solid #dddddd;
    font-size: 2.93vw;
    color: #333333;
    background: url("../assets/customer.png") no-repeat center 2.67vw #ffffff;
    background-size: 5.33vw;
    vertical-align: middle;
    text-decoration: none;
  }

  .price {
    flex-grow: 42;
    height: 14.67vw;
    line-height: 14.67vw;
    text-align: center;
    font-size: 4.8vw;
    color: #ff9000;
    background: #ffffff;
  }

  .submit-btn {
    flex-grow: 42;
    height: 14.67vw;
    line-height: 14.67vw;
    text-align: center;
    font-size: 4.56vw;
    color: #ffffff;
    background: #3385ff;
  }
}
</style>
